import React, { Component } from 'react';
//import './socialIcons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagramSquare, faTwitterSquare, faYoutubeSquare, faLinkedin, faPinterestSquare, faTumblrSquare } from '@fortawesome/free-brands-svg-icons';
import { faBlog } from '@fortawesome/free-solid-svg-icons';

export class SocialIcons extends Component {
    static displayName = SocialIcons.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            facebookLink: null,
            instagramLink: null,
            twitterLink: null,
            youtubeLink: null,
            linkedinLink: null,
            pinterestLink: null,
            tumblrLink: null,
            blogLink: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let facebookLink = (this.state.facebookLink != null && this.state.facebookLink != "" && this.state.facebookLink != undefined) ? <a href={this.state.facebookLink} aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebookSquare} aria-hidden="true" /> <span>Facebook</span><span className="sr-only">(opens in new tab)</span></a> : null;
        let instagramLink = (this.state.instagramLink != null && this.state.instagramLink != "" && this.state.instagramLink != undefined) ? <a href={this.state.instagramLink} aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagramSquare} aria-hidden="true" /> <span>Instagram</span><span className="sr-only">(opens in new tab)</span></a> : null;
        let twitterLink = (this.state.twitterLink != null && this.state.twitterLink != "" && this.state.twitterLink != undefined) ? <a href={this.state.twitterLink} aria-label="Twitter" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTwitterSquare} aria-hidden="true" /> <span>Twitter</span><span className="sr-only">(opens in new tab)</span></a> : null;
        let youtubeLink = (this.state.youtubeLink != null && this.state.youtubeLink != "" && this.state.youtubeLink != undefined) ? <a href={this.state.youtubeLink} aria-label="YouTube" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faYoutubeSquare} aria-hidden="true" /> <span>YouTube</span><span className="sr-only">(opens in new tab)</span></a> : null;
        let linkedinLink = (this.state.linkedinLink != null && this.state.linkedinLink != "" && this.state.linkedinLink != undefined) ? <a href={this.state.linkedinLink} aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedin} aria-hidden="true" /> <span>LinkedIn</span><span className="sr-only">(opens in new tab)</span></a> : null;
        let pinterestLink = (this.state.pinterestLink != null && this.state.pinterestLink != "" && this.state.pinterestLink != undefined) ? <a href={this.state.pinterestLink} aria-label="Pinterest" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faPinterestSquare} aria-hidden="true" /> <span>Pinterest</span><span className="sr-only">(opens in new tab)</span></a> : null;
        let tumblrLink = (this.state.tumblrLink != null && this.state.tumblrLink != "" && this.state.tumblrLink != undefined) ? <a href={this.state.tumblrLink} aria-label="Tumblr" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTumblrSquare} aria-hidden="true" /> <span>Tumblr</span><span className="sr-only">(opens in new tab)</span></a> : null;
        //let blogLink = (this.state.blogLink != null && this.state.blogLink != "" && this.state.blogLink != undefined) ? <a href={this.state.blogLink} alt="blog link" className='non-hollow-icon' target="_blank"><FontAwesomeIcon icon={faBlog} alt="blog icon" /></a> : null;

        let containerClasses = this.props.isInNavbar ? "social-icons social-icons--navbar" : "social-icons";
        return (
            <div className={containerClasses}>
                {facebookLink}
                {instagramLink}
                {twitterLink}
                {youtubeLink}
                {linkedinLink}
                {pinterestLink}
                {tumblrLink}
                {/*{blogLink}*/}
            </div>
        );
    }

    async getComponentData() {
        if (this.state.componentId != null && this.state.componentId != 0) {
            const respond = await fetch('Components/GetSocialInfo?componentId=' + this.state.componentId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await respond.json();

            if (data != null) {
                this.setState({
                    facebookLink: data.facebookLink,
                    instagramLink: data.instagramLink,
                    twitterLink: data.twitterLink,
                    youtubeLink: data.youtubeLink,
                    linkedinLink: data.linkedinLink,
                    pinterestLink: data.pinterestLink,
                    tumblrLink: data.tumblrLink,
                    blogLink: data.blogLink
                });
            }
        }
    }
}

export default SocialIcons;